import React, { useEffect, useState } from "react";
import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { CChart } from "@coreui/react-chartjs";
import { getStyle } from "@coreui/utils";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import SpatialTrackingOutlinedIcon from "@mui/icons-material/SpatialTrackingOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import CIcon from "@coreui/icons-react";
import { cilCloudDownload } from "@coreui/icons";
import WidgetsBrand from "../../views/widgets/WidgetsBrand";
import WidgetsDropdown from "../../views/widgets/WidgetsDropdown";
import { format } from "date-fns";
import "../Dashboard/dashboard.scss";

import {
  getAllCustomers,
  getAllEmplyeesData,
  getAllGroups,
  getDealers,
  getCollections,
  getCompanyDashboard,
} from "src/api/allApis";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();

  const [aaddharUsageCount, setaaddharUsageCount] = useState(0);
  const [aaddharTokenBalance, setaaddharTokenBalance] = useState(0);
  const [customerData, setCustomerData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [emiData, setEmiData] = useState([]);
  const schema = sessionStorage.getItem("schemaName");
  const [latestCustomerData, setLatestCustomerData] = useState([]);
  const [customerDatas, setCustomerDatas] = useState();
  const [totalCustomerData, setTotalCustomerDatas] = useState();
  const [monthCounts, setMonthCounts] = useState([]);
  const [activeView, setActiveView] = useState("Month");

  useEffect(() => {
    const companyId = sessionStorage.getItem("companyId");
    fetchCustomers();
    totalDisbursementAmount();
    totalApprovedLoans();
    fetchEMIs();
    fetchStaff();
    // fetchAllGroups();
    fetchAllDealers();
    getCompanyDashboard({ companyId: companyId }).then((data) => {
      setaaddharUsageCount(data?.data?.aaddharUsageCount);
      setaaddharTokenBalance(data?.data?.aaddhar_token_limit);
    });
  }, []);

  const fetchCustomers = async () => {
    getAllCustomers({ schemaName: schema })
      .then((users) => {
        setCustomerData(users?.data);
        setCustomerDatas(users?.data?.map((ele) => ele?.createdAt));
      })
      .catch((error) => console.error("err", error));
  };
  useEffect(() => {
    if (customerDatas) {
      const formattedDates = customerDatas?.map((dateString) => {
        const date = new Date(dateString);
        return format(date, " MMMM");
      });
      setTotalCustomerDatas(formattedDates);
    }
  }, [customerData]);

  useEffect(() => {
    if (totalCustomerData) {
      const counts = totalCustomerData.reduce((acc, curr) => {
        const month = curr.trim(); // Remove leading space
        acc[month] = (acc[month] || 0) + 1;
        return acc;
      }, {});

      const result = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ].map((month) => counts[month] || 0);

      setMonthCounts(result);
    }
  }, [totalCustomerData]);

  const fetchStaff = () => {
    getAllEmplyeesData({ schemaName: schema })
      .then((users) => setStaffData(users?.data))
      .catch((error) => console.error("err", error));
  };

  // const fetchAllGroups = () => {
  //   getAllGroups({ schemaName: schema })
  //     .then((users) => setGroupData(users?.data))
  //     .catch((error) => console.error("err", error));
  // };

  const fetchAllDealers = () => {
    getDealers({ schemaName: schema })
      .then((users) => setBranchData(users?.data))
      .catch((error) => console.error("err", error));
  };
  const fetchEMIs = () => {
    getCollections({ schemaName: schema })
      .then((users) => setEmiData(users?.data))
      .catch((error) => console.error("err", error));
  };

  const totalDisbursementAmount = () => {
    let subTotal = 0;
    customerData?.map((item) =>
      item?.disbursements?.map(
        (amt) => (subTotal += Number(amt?.DisbursementAmount))
      )
    );

    return subTotal;
  };
  const totalApprovedLoans = () => {
    let subTotal = 0;
    customerData?.map(
      (item) => (subTotal += Number(item?.loanApprovalStatus === "approved"))
    );

    return subTotal;
  };
  const totalPendingLoans = () => {
    let subTotal = 0;
    customerData?.map(
      (item) => (subTotal += Number(item?.loanApprovalStatus === "pending"))
    );

    return subTotal;
  };
  const totalRejectedLoans = () => {
    let subTotal = 0;
    customerData?.map(
      (item) => (subTotal += Number(item?.loanApprovalStatus === "rejected"))
    );

    return subTotal;
  };

  const progressExample = [
    {
      title: "Total applications",
      value: `${customerData?.length}`,
      percent: 10,
      color: "success",
    },
    {
      title: "Pending Loans",
      value: totalPendingLoans(),
      percent: 20,
      color: "info",
    },
    {
      title: "Approved Loans",
      value: totalApprovedLoans(),
      percent: 60,
      color: "warning",
    },
    {
      title: "Rejected Loans",
      value: totalRejectedLoans(),
      percent: 80,
      color: "danger",
    },
  ];

  useEffect(() => {
    const sortedData = customerData?.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });

    const latestData = sortedData?.slice(0, 10);
    setLatestCustomerData(latestData);
  }, [customerData]);

  return (
    <>
      <div className="content" style={{ paddingTop: "70px", height: "100%" }}>
        {/* Container for the Navigation and Buttons */}
        <div
          className="icon-buttons-container"
          style={{
            display: "flex",
            gap: "20px",
            paddingLeft: "35px",
            paddingBottom: "10px", // Added padding to separate from content below
          }}
        >
          <Tooltip title="Add Customer icon-buttons-container">
            <IconButton
              onClick={() => navigate("/newregisterform")}
              style={{ color: "white" }}
            >
              <PersonAddIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Take Loan">
            <IconButton
              onClick={() => navigate("/customers")}
              style={{ color: "white" }}
            >
              <CreditScoreIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Products">
            <IconButton
              onClick={() => navigate("/productlist")}
              style={{ color: "white" }}
            >
              <CategoryOutlinedIcon />
            </IconButton>
          </Tooltip>



          <Tooltip title="Track Customer">
            <IconButton
              onClick={() => navigate("/customer-profile")}
              style={{ color: "white" }}
            >
              <SpatialTrackingOutlinedIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Banking">
            <IconButton
              onClick={() => navigate("/banking")}
              style={{ color: "white" }}
            >
              <AccountBalanceOutlinedIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Bank Statement">
            <IconButton
              onClick={() => navigate("/bankstatement")}
              style={{ color: "white" }}
            >
              <ReceiptOutlinedIcon />
            </IconButton>
          </Tooltip>
        </div>
        {/* Container for the WidgetsDropdown and Traffic Chart */}
        <div className="widgets-page">
          <WidgetsDropdown
            usersCount={customerData?.length}
            incomeCount={totalDisbursementAmount()}
            aaddharUsageCount={aaddharUsageCount}
            aaddharTokenBalance={aaddharTokenBalance}
          />

          <div
            className="traffic-chart-row"
            style={{ flex: 1, minWidth: "300px", marginBottom: "25px 25px" }}
          >
            <CCard className="mb-4" style={{ height: "100%" }}>
              <CCardBody style={{ height: "100%" }}>
                <CRow>
                  <CCol sm={6}>
                    <h4>Traffic</h4>
                    <div className="small">January - December</div>
                  </CCol>
                  <CCol sm={6} className="d-none d-md-block">
                    <CButton color="primary" className="float-end">
                      Traffic
                    </CButton>
                    <CButtonGroup className="float-end me-3">
                      {["Day", "Month", "Year"].map((value) => (
                        <CButton
                          color="outline-secondary"
                          key={value}
                          className="mx-0"
                          active={value === activeView}
                          onClick={() => setActiveView(value)}
                        >
                          {value}
                        </CButton>
                      ))}
                    </CButtonGroup>
                  </CCol>
                </CRow>

                {/* Chart Section */}
                <CRow>
                  <CCol>
                    <CChart
                      type="bar"
                      data={{
                        labels: [
                          "January",
                          "February",
                          "March",
                          "April",
                          "May",
                          "June",
                          "July",
                          "August",
                          "September",
                          "October",
                          "November",
                          "December",
                        ],
                        datasets: [
                          {
                            label: "Customer Creations",
                            backgroundColor: (context) => {
                              const { dataIndex } = context;
                              const colors = [
                                "#F87979",
                                "#ff9e8a",
                                "#ffb08c",
                                "#f8cc8a",
                                "#ffeb8a",
                                "#a1e080",
                                "#8cd9f8",
                                "#7f7ffe",
                                "#a080f8",
                                "#ff7fe5",
                                "#ff7f7f",
                                "#a8ff7f",
                              ];
                              return colors[dataIndex % colors.length];
                            },
                            data: monthCounts,
                            borderColor: "#ffffff",
                            borderWidth: 2,
                            barThickness: 35,
                            borderRadius: 10,
                            hoverBackgroundColor: "#ffcd39",
                            hoverBorderColor: "#ffffff",
                            tension: 0.4,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                            labels: {
                              font: { size: 16 },
                              padding: 1,
                              color: "rgba(0, 0, 0, 0.75)",
                            },
                          },
                          tooltip: {
                            backgroundColor: "#333",
                            titleColor: "#fff",
                            bodyColor: "#fff",
                            bodyFont: { size: 14 },
                            footerColor: "#fff",
                            footerFont: { size: 12 },
                            callbacks: {
                              label: (tooltipItem) =>
                                `Count: ${tooltipItem.raw}`,
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: { color: "#D6D6D6", borderColor: "#D6D6D6" },
                            ticks: {
                              font: { size: 14 },
                              color: "rgba(0, 0, 0, 0.75)",
                            },
                          },
                          y: {
                            grid: { color: "#D6D6D6" },
                            ticks: {
                              font: { size: 14 },
                              color: "rgba(0, 0, 0, 0.75)",
                            },
                          },
                        },
                        interaction: {
                          mode: "nearest",
                          axis: "x",
                          intersect: false,
                        },
                        layout: {
                          padding: { top: 30, left: 30, right: 30, bottom: 30 },
                        },
                        animation: { duration: 1000, easing: "easeInOutQuad" },
                      }}
                      style={{
                        height: "100%",
                        width: "100%",
                        maxHeight: "350px", // Set a maximum height of 350px
                        marginTop: "20px",
                      }}
                    />
                  </CCol>
                </CRow>
              </CCardBody>

              {/* Footer Section */}
              <CCardFooter>
                <CRow
                  className="text-center"
                  style={{ width: "50%", marginRight: "auto", marginLeft: "0" }}
                >
                  {progressExample.map((item, index) => (
                    <CCol key={index}>
                      <div>{item.title}</div>
                      <strong>{item.value}</strong>
                      <CProgress
                        thin
                        className="mt-2"
                        color={item.color}
                        value={item.percent}
                      />
                    </CCol>
                  ))}
                </CRow>
              </CCardFooter>
            </CCard>
          </div>
        </div>

        {/* <WidgetsBrand withCharts className="col-12 col-lg-6 offset-lg-6" /> */}

        <CRow>
          <CCol xs>
            <CCard className="mb-4 custom-card ">
              <CCardHeader className="custom-card-header">
                <h5>Traffic {" & "} Sales</h5>
              </CCardHeader>
              <CCardBody style={{ padding: 0 }}>
                {/* <CRow>
                  <CCol xs={12} md={6} xl={6}>
                    <CRow>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-info py-1 px-3">
                          <div className="text-medium-emphasis small">
                            New Clients
                          </div>
                          <div className="fs-5 fw-semibold">
                            {metaData?.newUsersCount}
                          </div>
                        </div>
                      </CCol>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-danger py-1 px-3 mb-3">
                          <div className="text-medium-emphasis small">
                            Due EMI Collection
                          </div>
                          <div className="fs-5 fw-semibold">
                            {metaData?.dueEMICollection}
                          </div>
                        </div>
                      </CCol>
                    </CRow>

                    <hr className="mt-0" />
                    {progressGroupExample1?.map((item, index) => (
                      <div className="progress-group mb-4" key={index}>
                        <div className="progress-group-prepend">
                          <span className="text-medium-emphasis small">
                            {item.title}
                          </span>
                        </div>
                        <div className="progress-group-bars">
                          <CProgress thin color="info" value={item?.value1} />
                          <CProgress thin color="danger" value={item?.value2} />
                        </div>
                      </div>
                    ))}
                  </CCol>

                  <CCol xs={12} md={6} xl={6}>
                    <CRow>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-warning py-1 px-3 mb-3">
                          <div className="text-medium-emphasis small">
                            {"Today's EMI Collection"}
                          </div>
                          <div className="fs-5 fw-semibold">
                            {metaData?.todayEMICollection}
                          </div>
                        </div>
                      </CCol>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-success py-1 px-3 mb-3">
                          <div className="text-medium-emphasis small">
                            Pending
                          </div>
                          <div className="fs-5 fw-semibold">
                            {totalPendingEMIs()}
                          </div>
                        </div>
                      </CCol>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-success py-1 px-3 mb-3">
                          <div className="text-medium-emphasis small">
                            Paid EMIs
                          </div>
                          <div className="fs-5 fw-semibold">
                            {totalPaidEMIs()}
                          </div>
                        </div>
                      </CCol>
                      <CCol sm={6}>
                        <div className="border-start border-start-4 border-start-success py-1 px-3 mb-3">
                          <div className="text-medium-emphasis small">
                            Paid EMIs
                          </div>
                          <div className="fs-5 fw-semibold">
                            {totalPaidEMIs()}
                          </div>
                        </div>
                      </CCol>
                    </CRow>

                    <hr className="mt-0" />

                    {progressGroupExample2?.map((item, index) => (
                      <div className="progress-group mb-4" key={index}>
                        <div className="progress-group-header">
                          <CIcon className="me-2" icon={item?.icon} size="lg" />
                          <span>{item?.title}</span>
                          <span className="ms-auto fw-semibold">
                            {item?.value}%
                          </span>
                        </div>
                        <div className="progress-group-bars">
                          <CProgress thin color="warning" value={item?.value} />
                        </div>
                      </div>
                    ))}

                    <div className="mb-5"></div>

                    {progressGroupExample3?.map((item, index) => (
                      <div className="progress-group" key={index}>
                        <div className="progress-group-header">
                          <CIcon className="me-2" icon={item.icon} size="lg" />
                          <span>{item.title}</span>
                          <span className="ms-auto fw-semibold">
                            {item.value}{" "}
                            <span className="text-medium-emphasis small">
                              ({item.percent}%)
                            </span>
                          </span>
                        </div>
                        <div className="progress-group-bars">
                          <CProgress
                            thin
                            color="success"
                            value={item.percent}
                          />
                        </div>
                      </div>
                    ))}
                  </CCol>
                </CRow> */}
                {/* <CRow md={12}>
                  <CCol md="6">
                    <h5 style={{ marginBottom: "10px" }}>Dealers</h5>
                    <CTable
                      align="middle"
                      className="mb-0 border"
                      hover
                      responsive
                    >
                      <CTableHead color="light">
                        <CTableRow>
                          <CTableHeaderCell>SR No</CTableHeaderCell>
                          <CTableHeaderCell>Branch Name</CTableHeaderCell>
                          <CTableHeaderCell className="text-center">
                            Branch Code
                          </CTableHeaderCell>

                          <CTableHeaderCell>Contact Number</CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>
                      <CTableBody>
                        {branchData?.map((item, index) => (
                          <CTableRow v-for="item in tableItems" key={index}>
                            <CTableDataCell>
                              <div>{index + 1}</div>
                            </CTableDataCell>
                            <CTableDataCell>
                              <div>
                                {item?.branchName ? item?.branchName : "--"}
                              </div>
                            </CTableDataCell>

                            <CTableDataCell className="text-center">
                              {item?.branchCode}
                            </CTableDataCell>
                            <CTableDataCell>
                              {item?.contactNumber}
                            </CTableDataCell>
                          </CTableRow>
                        ))}
                      </CTableBody>
                    </CTable>
                  </CCol>
                  <CCol md="6">
                    <h5 style={{ marginBottom: "10px" }}>Groups</h5>
                    <CTable
                      align="middle"
                      className="mb-0 border"
                      hover
                      responsive
                    >
                      <CTableHead color="light">
                        <CTableRow>
                          <CTableHeaderCell>SR No</CTableHeaderCell>
                          <CTableHeaderCell>Group Name</CTableHeaderCell>
                          <CTableHeaderCell className="text-center">
                            Group HeadName
                          </CTableHeaderCell>

                          <CTableHeaderCell>Group Code</CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>
                      <CTableBody>
                        {groupData?.map((item, index) => (
                          <CTableRow v-for="item in tableItems" key={index}>
                            <CTableDataCell>
                              <div>{index + 1}</div>
                            </CTableDataCell>
                            <CTableDataCell>
                              <div>
                                {item?.groupName ? item?.groupName : "--"}
                              </div>
                            </CTableDataCell>
                            <CTableDataCell className="text-center">
                              {item?.groupHeadName}
                            </CTableDataCell>

                            <CTableDataCell>{item?.groupCode}</CTableDataCell>
                          </CTableRow>
                        ))}
                      </CTableBody>
                    </CTable>
                  </CCol>
                </CRow> */}
                <div className=" new-table-container table-section-wrapper">
                  <h5
                    style={{
                      marginBottom: "10px",
                      backgroundColor: "#f0f0f0",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    Staff{" "}
                  </h5>
                  <CTable
                    align="middle"
                    className="new-table-container new-common-table-wrapper custom-tablee"
                    hover
                    responsive
                  >
                    <CTableHead color="light">
                      <CTableRow>
                        <CTableHeaderCell>SR No</CTableHeaderCell>
                        <CTableHeaderCell>Name</CTableHeaderCell>
                        <CTableHeaderCell className="text-center">
                          Email
                        </CTableHeaderCell>
                        <CTableHeaderCell>AadharNumber</CTableHeaderCell>
                        <CTableHeaderCell className="text-center">
                          Branch Name
                        </CTableHeaderCell>
                        <CTableHeaderCell>Contact Number</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {staffData?.map((item, index) => (
                        <CTableRow v-for="item in tableItems" key={index}>
                          <CTableDataCell>
                            <div>{index + 1}</div>
                          </CTableDataCell>
                          <CTableDataCell>
                            <div>
                              {item?.firstName ? item?.firstName : "--"}
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="text-center">
                            {item?.email}
                          </CTableDataCell>
                          <CTableDataCell>{item?.aadharNumber}</CTableDataCell>
                          <CTableDataCell className="text-center">
                            {item?.branch?.branchName}
                          </CTableDataCell>
                          <CTableDataCell>{item?.phoneNumber}</CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                  <br />
                  <h5
                    style={{
                      marginBottom: "10px",
                      backgroundColor: "#f0f0f0",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    New Customers
                  </h5>
                  <CTable
                    align="middle"
                    className=" new-table-container new-common-table-wrapper mb-0 border custom-tablee"
                    hover
                    responsive
                  >
                    <CTableHead color="light">
                      <CTableRow>
                        <CTableHeaderCell>SR No</CTableHeaderCell>
                        <CTableHeaderCell>Name</CTableHeaderCell>
                        <CTableHeaderCell className="text-center">
                          Email
                        </CTableHeaderCell>
                        <CTableHeaderCell>
                          Loan Amount Requested
                        </CTableHeaderCell>
                        <CTableHeaderCell className="text-center">
                          Aadhar Number
                        </CTableHeaderCell>
                        <CTableHeaderCell className="text-center">
                          Contact Number
                        </CTableHeaderCell>
                        <CTableHeaderCell>Father Name</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {latestCustomerData?.map((item, index) => (
                        <CTableRow v-for="item in tableItems" key={index}>
                          <CTableDataCell>
                            <div>{index + 1}</div>
                          </CTableDataCell>
                          <CTableDataCell>
                            <div>{item?.firstName}</div>
                          </CTableDataCell>
                          <CTableDataCell className="text-center">
                            {item?.email ? item?.email : "--"}
                          </CTableDataCell>
                          <CTableDataCell>
                            {item?.loanAmountRequested
                              ? item?.loanAmountRequested
                              : "--"}
                          </CTableDataCell>
                          <CTableDataCell className="text-center">
                            {item?.aadharNumber ? item?.aadharNumber : ""}
                          </CTableDataCell>
                          <CTableDataCell className="text-center">
                            {item?.phoneNumber ? item?.phoneNumber : "--"}
                          </CTableDataCell>
                          <CTableDataCell>
                            {item?.fatherName ? item?.fatherName : "--"}
                          </CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>
    </>
  );
};

export default Dashboard;
